/**
 * Created by kz on 28.06.17.
 */
export const all = (state) => {
  return state.mailings
}

export const current = (state) => {
  return state.current
}



// WEBPACK FOOTER //
// ./src/store/modules/mailing/getters.js